// extracted by mini-css-extract-plugin
module.exports = {"modal":"src-reactapp-Settings-FeaturedMedia---modal"};